import { HiverKbBifrost } from "./Bifrost";
import { API_METHODS } from "./Constant/Bifrost";
import { apiRoutes, Hiver_New_Auth_Base_Url } from "./Constant/ApiRoutes";

import { processUrl } from "./utils";

// Bifrost does not append params as query string for non-GET methods.
// This helper manually appends them to the URL.
const appendParamsToUrl = (url, params) => {
  if (!params) return url;
  const searchParams = new URL(Hiver_New_Auth_Base_Url + url);
  Object.keys(params).forEach((key) => {
    if (params[key] != null) {
      searchParams.searchParams.append(key, params[key]);
    }
  });
  return searchParams?.search ? url + searchParams.search : url;
};

// Routes that mount on the Python backend without a {subdomain} path
// segment must skip processUrl, otherwise the usergroup slug gets
// prepended and the route 404s. Add new subdomain-less routes here.
const SUBDOMAIN_LESS_ROUTES = new Set([
  apiRoutes.availableFeatures,
  apiRoutes.kbList,
]);

export const getRequest = (
  url,
  payload
) => {
  if (!SUBDOMAIN_LESS_ROUTES.has(url)) url = processUrl(url);
  url = appendParamsToUrl(url, payload);

  return HiverKbBifrost({
    url,
    method: API_METHODS.GET,
    root_url: Hiver_New_Auth_Base_Url
  });
};

export const postRequest = (url, payload, params) => {
    url = processUrl(url);
    url = appendParamsToUrl(url, params);

    return HiverKbBifrost({
      url,
      method: API_METHODS.POST,
      data: payload,
      root_url: Hiver_New_Auth_Base_Url
    });
};

export const putRequest = (url, payload, params) => {
  url = processUrl(url);
  url = appendParamsToUrl(url, params);

  return HiverKbBifrost({
    url,
    method: API_METHODS.PUT,
    data: payload,
    root_url: Hiver_New_Auth_Base_Url
  });
};

export const patchRequest = (url, payload, params) => {
  url = processUrl(url);
  url = appendParamsToUrl(url, params);

  return HiverKbBifrost({
    url,
    method: API_METHODS.PATCH,
    data: payload,
    root_url: Hiver_New_Auth_Base_Url
  });
};

export const deleteRequest = (url, bodyPayload, urlPayload) => {
  url = processUrl(url);
  url = appendParamsToUrl(url, urlPayload);

  return HiverKbBifrost({
    url,
    method: API_METHODS.DELETE,
    data: Array.isArray(bodyPayload) ? [...bodyPayload] : { ...bodyPayload },
    root_url: Hiver_New_Auth_Base_Url,
  });
};
